import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { freeBetStore } from '../../../store/freeBetStore';
import { applicationStore } from '../../../store/applicationStore';

import FreeBet from '../../../components/common/freeBet';
import { menuSectionStore } from '../../../store/menuSectionStore';

const FreeBetWrapper = observer(() => {
  const { isShowFreeBetPopup } = freeBetStore;
  const { setIsShowBlackLayer } = applicationStore;
  const { isShowMenuPopup } = menuSectionStore;

  useEffect(() => {
    if (!isShowMenuPopup) {
      setIsShowBlackLayer(isShowFreeBetPopup);
    }
  }, [isShowMenuPopup, isShowFreeBetPopup, setIsShowBlackLayer]);

  if (!isShowFreeBetPopup) return null;

  return (
      <Container name='FreeBetWrapperContainer'>
        <FreeBet />
      </Container>
  );
});

export default FreeBetWrapper;
